/** React entrypoint, loaded by index.html and bundled by Bun. */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import { LocaleProvider } from "./lib/i18n.tsx";
import { ThemeProvider } from "./lib/theme.tsx";
import "./styles/app.css";
import { FONT_FACE_CSS } from "./styles/fonts.ts";

// Inject the self-hosted @font-face rules at runtime (see fonts.ts): a plain
// <style> the Bun bundler never asset-processes, so the woff2 stay served by the
// app's own /fonts/* route — same-origin, satisfying the strict platform CSP.
const fontStyle = document.createElement("style");
fontStyle.textContent = FONT_FACE_CSS;
document.head.appendChild(fontStyle);

const container = document.getElementById("root");
if (!container) throw new Error("missing #root");
createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <LocaleProvider>
        <App />
      </LocaleProvider>
    </ThemeProvider>
  </StrictMode>,
);
